import { fetchUrlData } from "../Helper_functions";
import {Survey ,SurveyInfo , SurveyQuestions} from "./interfaces";

const survey_url = "https://mat-facilitator-backend.vercel.app/api/surveys";
const survey_info_url = "https://mat-facilitator-backend.vercel.app/api/surveys_info/published";
const privacy_form_url = "https://mat-facilitator-backend.vercel.app/api/privacy_form";


export const checkAndUpdateSurveys = async() => {
    // all ways returns the first survey
    let surveys = await fetchSurveys();
    if (!surveys) {
        console.log("no surveys");
        return;
    }

    surveys.forEach(survey => {
            let cachedSurvey = getCachedSurvey(survey.id);
            console.log(cachedSurvey);
            if (!cachedSurvey ||cachedSurvey.version != survey.version) {
                // no survey with that id in the cache, add
                console.log("update survey");
                updateCachedSurvey(survey);
                return;
            }
    });
}
export const checkAndUpdateSurveyKeys = async() => {
    // I want to get all keys, if they are different from the ones in the cache, update them
    let surveys_keys = await fetchSurveyInfoKeys();
    let cached_keys = getCashedSurveysIds();
    if (!surveys_keys) {
        console.log("no keys");
        return;
    }
    if (!cached_keys) {
        console.log("no cached keys");
        localStorage.setItem("survey_keys", JSON.stringify(surveys_keys));
        return;
    }
    if (JSON.stringify(surveys_keys) != JSON.stringify(cached_keys)) {
        console.log("keys are different");
        console.log(surveys_keys);
        console.log(cached_keys);
        localStorage.setItem("survey_keys", JSON.stringify(surveys_keys));
    }else{
        console.log("keys are the same");
    }
}
export const checkAndUpdatePrivacyForm = async() => {
    let privacyForm = await fetchPrivacyForm();
    if (!privacyForm) {
        console.log("no privacy form");
        return;
    }
    let cachedPrivacyForm = localStorage.getItem("privacy_form");
    if (!cachedPrivacyForm || cachedPrivacyForm != privacyForm) {
        console.log("update privacy form");
        localStorage.setItem("privacy_form", privacyForm);
    }
}
const fetchSurveys = async () => {
    let [surveys,error] = await fetchUrlData<Survey[]>(survey_url);
    if(error){
        console.log(error);
    }
    return surveys;
}
const fetchPrivacyForm = async () => {
    let [privacyForm,error] = await fetchUrlData<{markdown:string}>(privacy_form_url);
    if(error){
        console.log(error);
    }
    return privacyForm?.markdown;
}
export const getCachedSurvey = (id:number|string) => {
    let survey = localStorage.getItem(`survey-${id}`);
    if (survey) {
        return JSON.parse(survey) as Survey;
    }
    return null;
}
const fetchSurveyInfoKeys = async () => {
    let [SurveyInfo,error] = await fetchUrlData<SurveyInfo[]>(survey_info_url);
    if(error||!SurveyInfo){
        console.log(error);
        throw error;
    }
    // extract all ids from the SurveyInfo
    return SurveyInfo;
}

export const getCashedSurveysIds = () => {
    let surveys_keys = localStorage.getItem("survey_keys");
    if (surveys_keys) {
        let survey_keys_object = JSON.parse(surveys_keys) as SurveyInfo[];
       return survey_keys_object;
    }
    // empty object
    let empty = [] as SurveyInfo[];
    return empty;

}
const updateCachedSurvey = async(survey:Survey) => {
    console.log("update");
    localStorage.setItem(`survey-${survey.id}`, JSON.stringify(survey));
}


